<style scoped>  

  @media only screen and (max-width: 767px) {
    .search-button {
      margin-top: 16px;
    }
  }

  @media only screen and (min-width: 768px) {
    .search-button {
      margin-top: 24px;
    }
  }

</style>

<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form" @submit.prevent="onSearch()">      
      <div class="fields">
        <div class="three wide field">
          <label>Data Inicial <span class="red text">*</span></label>
          <div id="orders-start-date" class="ui calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" class="date">
            </div>
          </div>
        </div>
        <div class="three wide field">
          <label>Data Final <span class="red text">*</span></label>
          <div id="orders-end-date" class="ui calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" class="date">
            </div>
          </div>
        </div>
        <div class="three wide field">
          <button type="submit" class="ui basic blue icon button search-button" :class="{ loading }">
            <i class="search icon"></i>
            Pesquisar
          </button>
        </div>
      </div>
    </form>

    <div v-if="orders && orders.length > 0" class="ui segment animated fadeIn m-t-20">
      <table class="ui very basic celled selectable tablet stackable table">
        <thead class="desktop-only">
          <tr>
            <th>Status</th>
            <th>Filial</th>
            <th>Número</th>
            <th>Emissão</th>
            <th>Produção</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" class="clickable" @click="onShowOrder(order)">
            <td style="white-space: nowrap;">
              <i class="icon" :class="order.iconStatus + ' ' + order.colorStatus"></i> 
              {{ order.status }}
            </td>
            <td><strong class="mobile-only">Filial: </strong>{{ order.branch + ' - ' + $branchName(order.branch) }}</td>
            <td><strong class="mobile-only">Número: </strong>{{ order.id }}</td>
            <td><strong class="mobile-only">Emissão: </strong>{{ $formatDate(order.date) }}</td>
            <td><strong class="mobile-only">Produção: </strong>{{ $formatDate(order.deliveryDate) }}</td>
            <td><strong class="mobile-only">Total: </strong>R$ {{ $formatCurrency(order.total) }}</td>
          </tr>          
        </tbody>
      </table>
    </div>

    <sales-order-dialog ref="orderDialog" :branchId="selectedOrder.branch" :orderId="selectedOrder.id" />

  </div>

</template>

<script>

  import { Message, Calendar } from "@/utils"    
  import SalesOrderDialog from "@/components/sales-order-dialog.vue"
  import SalesOrderService from "@/services/sales-order-service"

  export default {    

    data() {
      return {
        loading: false,
        orders: null,
        selectedOrder: {},
      }
    },
    
    props: ["customer"],

    components: {
      SalesOrderDialog,
    },

    mounted() {

      Calendar.initInputs()      
    },

    methods: {

      async onSearch() {

        let startDate = $("#orders-start-date").calendar("get date")
        let endDate = $("#orders-end-date").calendar("get date")

        if (!startDate || !endDate) {
          Message.info("Defina o intervalo de datas")
          return
        }

        this.loading = true

        try {

          this.orders = await SalesOrderService.getCustomerOrders({            
            startDate,
            endDate,
            customerCode: this.customer.code,
            customerUnit: this.customer.unit,                  
          })

          this.loading = false

          if (this.orders.length == 0)
            Message.info("Nenhum registro encontrado")
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onShowOrder(order) {

        this.selectedOrder = order
        
        this.$refs.orderDialog.show()
      },
    },

  }

</script>

